module.exports = __webpack_public_path__ + "static/media/GroupsPerson.19e02484.svg";